import { motion } from "framer-motion";
import { siteConfig } from "../../data/content";
import { useLang } from "../../i18n/LanguageContext";

const EASE = [0.16, 1, 0.3, 1];

export const Hero = () => {
  const { t } = useLang();
  const go = (href) =>
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section
      id="home"
      data-testid="hero-section"
      className="relative min-h-screen flex items-end overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src={siteConfig.images.hero}
          alt="Modern Mediterranean residential architecture in Greece"
          className="h-full w-full object-cover"
          loading="eager"
          fetchPriority="high"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#1A1C19]/90 via-[#1A1C19]/45 to-[#1A1C19]/50" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#1A1C19]/80 via-[#1A1C19]/25 to-transparent" />
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-12 pb-20 md:pb-28 pt-40">
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: EASE }}
          className="text-[#C9BCA0] text-xs md:text-sm font-medium tracking-[0.3em] uppercase mb-6"
          data-testid="hero-overline"
        >
          {t.hero.overline}
        </motion.p>

        <motion.h1
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.1, ease: EASE }}
          className="font-serif text-[#F4F3EF] text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-[1.05] tracking-tight max-w-4xl"
          data-testid="hero-headline"
        >
          {t.hero.headline1}
          <br />
          {t.hero.headline2}
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.25, ease: EASE }}
          className="mt-8 text-base md:text-lg text-[#EAE8E3] max-w-2xl leading-relaxed"
          data-testid="hero-subtext"
        >
          {t.hero.subtext}
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.4, ease: EASE }}
          className="mt-12 flex flex-col sm:flex-row gap-4"
        >
          <button
            data-testid="hero-primary-cta"
            onClick={() => go("#contact")}
            className="bg-[#F4F3EF] text-[#1A1C19] px-8 py-4 text-sm font-semibold tracking-wide hover:bg-[#B5A68B] transition-colors duration-300"
          >
            {t.hero.primary}
          </button>
          <button
            data-testid="hero-secondary-cta"
            onClick={() => go("#about")}
            className="border border-[#F4F3EF]/60 text-[#F4F3EF] px-8 py-4 text-sm font-semibold tracking-wide hover:bg-[#F4F3EF] hover:text-[#1A1C19] transition-colors duration-300"
          >
            {t.hero.secondary}
          </button>
        </motion.div>
      </div>
    </section>
  );
};
